


















import { Component, Prop, Vue } from 'vue-property-decorator';
import Room from '@/models/Room';
import RoomListItem from '@/browser/moleculers/RoomListItem.vue';
import RoomSearchInput from '@/browser/atoms/RoomSearchInput.vue';

@Component({
  components: {
    RoomListItem,
    RoomSearchInput,
  },
})
export default class RoomList extends Vue {
  @Prop({ required: true }) private rooms!: Room[];

  pagination = {
    page: 0,
    rowsPerPage: 25,
  };
  searchText: string | null = null;

  get searchResults(): Room[] {
    const {
      rooms,
      searchText,
    } = this;

    if (!searchText) return rooms;
    return rooms.filter(room => room.title.match(searchText));
  }
}
